import { createClient } from '@supabase/supabase-js';

// Use environment variables for Supabase configuration
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://xluclmoyleytktrhtkeb.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Check if we have the required environment variables
if (!SUPABASE_ANON_KEY) {
  console.error('VITE_SUPABASE_ANON_KEY is not set. Please check your environment variables.');
}

// Log configuration for debugging (without exposing sensitive data)
console.log('[Supabase] Configuration:', {
  url: SUPABASE_URL,
  hasAnonKey: !!SUPABASE_ANON_KEY,
  isDev: import.meta.env.DEV
});

// Define the production site URL
const SITE_URL = 'https://permitlab.govstream.ai';

// Create a single instance with fallback for missing anon key
export const supabase = createClient(
  SUPABASE_URL, 
  SUPABASE_ANON_KEY || 'fallback-key-for-development', // Provide fallback to prevent client creation failure
  {
    auth: {
      persistSession: true,
      storageKey: 'app-supabase-auth',
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      debug: import.meta.env.DEV && false, // Enable debug logging in development
      onAuthStateChange: (event, session) => {
        console.log('[Supabase] Auth state change:', event, session?.user?.id);
      },
      // Add additional settings for better password recovery handling
      storage: {
        getItem: (key) => {
          try {
            return localStorage.getItem(key);
          } catch {
            return null;
          }
        },
        setItem: (key, value) => {
          try {
            localStorage.setItem(key, value);
          } catch {
            // Ignore storage errors
          }
        },
        removeItem: (key) => {
          try {
            localStorage.removeItem(key);
          } catch {
            // Ignore storage errors
          }
        }
      }
    }
  }
);